/**
 * CIDR プランナー共通型
 */

export type IpCountMode = 'standard' | 'aws';

export type CidrBlock = {
  id: string;
  cidr: string;
  name: string;
};

export type AddressRange = {
  start: bigint;
  end: bigint;
};

export type ParsedCidr = {
  network: bigint;
  prefix: number;
  broadcast: bigint;
};

export type CidrValidationResult =
  | { ok: true; normalized: string; wasNormalized: boolean }
  | { ok: false; error: string };

export type PlannerState = {
  parentCidr: string;
  blocks: CidrBlock[];
  ipCountMode: IpCountMode;
  /** テキスト編集で最後に反映した生テキスト（コメント・空行を含む） */
  blocksText: string | null;
};

export const DEFAULT_PARENT_CIDR = '10.0.0.0/16';

export const DEFAULT_PLANNER_STATE: PlannerState = {
  parentCidr: DEFAULT_PARENT_CIDR,
  blocks: [],
  ipCountMode: 'standard',
  blocksText: null,
};
